import React, { useState } from 'react';
import { Row, Tabs, Col, Drawer, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import TransactionsAcquiring from '@pages/Assets/TransactionsAcquiring';
import TabPanesDetails from './TabPanesDetails';
import TabPaneInventory from './TabPaneInventory';

import * as S from './styles';

const { TabPane } = Tabs;
const { useBreakpoint } = Grid;

interface IPreviewProps {
  deviceProps: any;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConnectedDevicesPreview = ({
  deviceProps,
  isOpen,
  setIsOpen,
}: IPreviewProps) => {
  const { t } = useTranslation('connected-devices');
  const screens = useBreakpoint();
  const [page, setPage] = useState<string | number | undefined>(0);
  const [linesPerPage, setLinesPerPage] = useState<string | number | undefined>(
    20,
  );
  return (
    <Drawer
      title={t('preview-tabs.title')}
      width={screens?.xs ? '90%' : '60%'}
      placement="right"
      onClose={() => {
        setIsOpen(false);
        setLinesPerPage(20);
        setPage(0);
      }}
      destroyOnClose
      open={isOpen}
      className="preview-drawer"
    >
      <S.DevicesContainer className="test">
        <Tabs defaultActiveKey="1">
          <TabPane tab={t('preview-tabs.details')} key="1">
            <TabPanesDetails device={deviceProps} />
          </TabPane>

          <TabPane tab={t('preview-tabs.inventory')} key="3">
            <Row gutter={[24, 24]}>
              <Col lg={24} md={24} xl={24} xs={24}>
                <TabPaneInventory iccid={deviceProps?.iccid} />
              </Col>
            </Row>
          </TabPane>

          <TabPane tab={t('preview-tabs.transactions')} key="4">
            <Row gutter={[24, 24]}>
              <Col lg={24} md={24} xl={24} xs={24}>
                <TransactionsAcquiring
                  defaultFilters={{
                    deviceNumber: deviceProps?.deviceNumber,
                    page: Number(page) > 0 ? Number(page) - 1 : 0,
                    linesPerPage,
                  }}
                  defaultPagination={{ page, linesPerPage }}
                  setDefaultPaginationChange={values => {
                    setPage(values?.page);
                    setLinesPerPage(values?.linesPerPage);
                  }}
                />
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </S.DevicesContainer>
    </Drawer>
  );
};

export default ConnectedDevicesPreview;
